import Tab from "@mui/joy/Tab";
import Table from "@mui/joy/Table";
import TabList from "@mui/joy/TabList";
import TabPanel from "@mui/joy/TabPanel";
import Tabs from "@mui/joy/Tabs";
import React from "react";
import { Tables } from "../../supabase/supabase";

interface ScoreboardProps {
  todayTriviaScores: Tables<"triviaScores">[];
  allTimeTriviaScores: Tables<"triviaScores">[];
  userId: number;
}

export default function Scoreboard({
  todayTriviaScores,
  allTimeTriviaScores,
  userId,
}: ScoreboardProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 max-w-md">
      <div className="flex flex-row font-bold text-2xl text-center">
        Leaderboard
      </div>
      <Tabs aria-label="Basic tabs" defaultValue={0}>
        <TabList tabFlex={1}>
          <Tab color="primary">Today</Tab>
          <Tab color="primary">All Time</Tab>
        </TabList>
        <TabPanel sx={{ paddingTop: 0 }} value={0}>
          <ScoreboardTable triviaScores={todayTriviaScores} userId={userId} />
        </TabPanel>
        <TabPanel sx={{ paddingTop: 0 }} value={1}>
          <ScoreboardTable triviaScores={allTimeTriviaScores} userId={userId} />
        </TabPanel>
      </Tabs>
    </div>
  );
}

interface ScoreboardTableProps {
  triviaScores: Tables<"triviaScores">[];
  userId: number;
}

function ScoreboardTable({ triviaScores, userId }: ScoreboardTableProps) {
  return (
    <Table
      borderAxis="xBetween"
      color="neutral"
      size="lg"
      stickyFooter={false}
      stickyHeader={false}
      variant="soft"
    >
      <thead>
        <tr>
          <th style={{ width: "80px" }}>Rank</th>
          <th>Name</th>
          <th style={{ width: "80px" }}>Score</th>
        </tr>
      </thead>
      <tbody>
        {triviaScores.length ? (
          triviaScores.map((score, i) => (
            <tr
              style={{ padding: "0 12px", height: "24px" }}
              key={i}
              className={`items-center justify-center align-center align-items ${
                score.user_id === userId ? "bg-yellow-200" : ""
              }`}
            >
              <td style={{ padding: "0 12px", height: "24px", width: "80px" }}>
                {i + 1}
              </td>
              <td
                className="truncate"
                style={{ padding: "0 12px", height: "24px" }}
              >{`${score.name}${
                score.user_id === userId ? " (You!)" : ""
              }`}</td>
              <td style={{ padding: "0 12px", height: "24px", width: "80px" }}>
                {score.score}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <th></th>
            <th>No players today</th>
            <th></th>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
